import React, { Component } from 'react'
import Navbar from '../components/Navbar'
import '../styles/Aboutme.css';

export default class Aboutme extends Component {
    render() {
        return (
            <div className='about-css'>
                <header className='dark-bg'>
                    <Navbar />
                </header>
            </div>

        )
    }
}
